import { CUSTOM_ITEM } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { LEVEL_ONE } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { PROJECT } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/item-type.tsx';
import { SECTION_ITEM_STARRED } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/section-type.tsx';
import { PROJECTS_NAVIGATION_ITEM } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/action-subject-id.tsx';
import { NAVIGATION_ITEM } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/action-subject-type.tsx';

export const PACKAGE_NAME = 'jira-navigation-apps-sidebar-nav4-projects-customise-order';
export const TEAM_NAME = 'jira-cosmos';
export const ANALYTIC_PAYLOAD = {
	UPDATED_ORDER: {
		action: 'updated',
		actionSubject: 'sidebarNavigationItems',
		actionSubjectId: PROJECTS_NAVIGATION_ITEM,
	},
	ATTRIBUTES: {
		level: LEVEL_ONE,
		componentType: CUSTOM_ITEM,
		itemType: PROJECT,
		section: SECTION_ITEM_STARRED,
	},
	DRAG_STARTED: {
		action: 'dragStarted',
		actionSubject: NAVIGATION_ITEM,
		actionSubjectId: PROJECTS_NAVIGATION_ITEM,
	},
	DRAG_LEFT: {
		action: 'dragLeft',
		actionSubject: NAVIGATION_ITEM,
		actionSubjectId: PROJECTS_NAVIGATION_ITEM,
	},
	DRAG_ENTERED: {
		action: 'dragEntered',
		actionSubject: NAVIGATION_ITEM,
		actionSubjectId: PROJECTS_NAVIGATION_ITEM,
	},
	DRAG_ENDED: {
		action: 'dragEnded',
		actionSubject: NAVIGATION_ITEM,
		actionSubjectId: PROJECTS_NAVIGATION_ITEM,
	},
};

export const NAV4_PROJECT_MENU_ITEM_DRAG_AND_DROP =
	'nav4-sidebar-project-menu-item-drag-and-drop' as const;
